
import React from "react";
import image2 from "../Images/latestsecond.png";
import { useNavigate, Link } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const handleRedirectAndScroll = (section) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }, 500);
  };

  const handleContact = () => {
    navigate("/Contact");
  };

  const navigateToHome = () => {
    navigate("/");
  };

  return (
    <div className="body">
      <div className="hero-section">
        <nav className="navbar navbar-expand-lg bg-body-tertiary shadow-sm p-0">
          <div className="container-fluid p-3 " >
            <div  >
              <img
                className="navbarlogo "
                src={image2}
                alt="Logo"
                onClick={navigateToHome}
                style={{ cursor: "pointer" }}
              />
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className=" navbar-nav mx-auto my-2 navbar-nav-scroll gap-3 fs-6 ">
                <li className="nav-item">
                  <Link
                    to={"/"}
                    onClick={() => handleRedirectAndScroll("Home")}
                    className="nav-link"
                    style={{ fontWeight: "600" }}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => handleRedirectAndScroll("Aboutus")}
                    className="nav-link"
                    style={{ fontWeight: "600" }}
                  >
                    About Us
                  </button>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={() => handleRedirectAndScroll("Services")}
                    className="nav-link"
                    style={{ fontWeight: "600" }}
                  >
                    Services
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={() => handleRedirectAndScroll("Detail")}
                    className="nav-link"
                    style={{ fontWeight: "600" }}
                  >
                    Detail
                  </Link>
                </li>
              </ul>
                <button
                  onClick={handleContact}
                  className="boton1 w-100 rounded-3 px-4 text-white p-2"
                  type="submit"
                > 
                  Contact us
                </button>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
